var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Microphone component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconMicrophone extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9998 2.60498C11.1639 2.60498 10.3622 2.93706 9.77108 3.52816C9.17998 4.11926 8.8479 4.92096 8.8479 5.7569V11.2196C8.8479 12.0555 9.17998 12.8572 9.77108 13.4483C10.3622 14.0394 11.1639 14.3715 11.9998 14.3715C12.8358 14.3715 13.6375 14.0394 14.2286 13.4483C14.8197 12.8572 15.1517 12.0555 15.1517 11.2196V5.7569C15.1517 4.92096 14.8197 4.11926 14.2286 3.52816C13.6375 2.93706 12.8358 2.60498 11.9998 2.60498ZM8.71042 2.4675C9.58282 1.59509 10.7661 1.10498 11.9998 1.10498C13.2336 1.10498 14.4168 1.59509 15.2892 2.4675C16.1616 3.3399 16.6517 4.52314 16.6517 5.7569V11.2196C16.6517 12.4534 16.1616 13.6366 15.2892 14.509C14.4168 15.3814 13.2336 15.8715 11.9998 15.8715C10.7661 15.8715 9.58282 15.3814 8.71042 14.509C7.83801 13.6366 7.3479 12.4534 7.3479 11.2196V5.7569C7.3479 4.52314 7.83801 3.3399 8.71042 2.4675ZM12.75 19.745C15.6114 19.6139 17.5482 18.427 18.7735 16.893C20.0746 15.2642 20.531 13.2999 20.531 11.9448C20.531 11.5306 20.1952 11.1948 19.781 11.1948C19.3668 11.1948 19.031 11.5306 19.031 11.9448C19.031 13.019 18.656 14.6368 17.6015 15.9569C16.5742 17.2429 14.8589 18.3035 12.0345 18.2555C12.0229 18.2553 12.0114 18.2553 11.9999 18.2557C11.9884 18.2553 11.9769 18.2553 11.9653 18.2555C9.14084 18.3035 7.42555 17.2429 6.39825 15.9569C5.34378 14.6368 4.96875 13.019 4.96875 11.9448C4.96875 11.5306 4.63296 11.1948 4.21875 11.1948C3.80454 11.1948 3.46875 11.5306 3.46875 11.9448C3.46875 13.2999 3.92518 15.2642 5.22626 16.893C6.45158 18.427 8.38845 19.614 11.25 19.745V22.145C11.25 22.5592 11.5858 22.895 12 22.895C12.4142 22.895 12.75 22.5592 12.75 22.145V19.745Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconMicrophone.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconMicrophone.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconMicrophone.prototype, "size", void 0);
if (customElements.get('cat-icon-microphone') === undefined) {
    customElements.define('cat-icon-microphone', BlocksIconMicrophone);
}
